module.exports = __webpack_public_path__ + "static/img/card2.551f119.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card2.jpg
// module id = 7Akg
// module chunks = 0